<template>
  <div
    class="sd-notif fade show notif-banner"
    :class="notification"
  >
    <svg-icon v-if="notification === 'success'" icon="checkmark_circle" class="success-icon" />
    <svg-icon v-if="notification === 'warning'" icon="information" class="warning-icon" />
    <svg-icon v-if="notification === 'danger'" icon="warning" class="danger-icon" />
    <div class="sd-notif-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      timeout: null
    };
  },
  props: {
    notification: {
      type: String,
      required: true
    }
  },
  mounted() {
    // this.timeout = setTimeout(() => this.remove(this.notification), 5000);
  },
  watch: {
    notification: {
      immediate: true,
      handler() {

      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  computed: {
    notificationTypeClass() {
      return `icon-${this.notification.type}`;
    }
  },
  methods: mapActions("notification", ["remove"])
};
</script>

<style scoped>
  /*.sd-notif.notif-banner {
    //background-color: red;
  }*/


  .sd-notif.notif-banner/deep/ ul {
    list-style: none;
    padding-left: 0;
    margin-bottom: 0;
  }

  .sd-notif.notif-banner/deep/ .svg-container {
    display: flex;
    align-self: flex-start;
  }
</style>
